/*
 * SonarQube
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import { MessageCallout, MessageCalloutProps } from '@sonarsource/echoes-react';
import { useCallback } from 'react';
import useLocalStorage from '../../helpers/useLocalStorage';

export interface DismissableMessageCalloutProps extends Exclude<MessageCalloutProps, 'onDismiss'> {
  alertKey: string;
}

export const DISMISSED_CALLOUT_STORAGE_KEY = 'sonarqube.dismissed_alert';

export function DismissableMessageCallout(props: Readonly<DismissableMessageCalloutProps>) {
  const { alertKey, children, className, variety } = props;
  const [dismissed, setDismissed] = useLocalStorage(`${DISMISSED_CALLOUT_STORAGE_KEY}.${alertKey}`);

  const handleCalloutDismiss = useCallback(() => {
    setDismissed(true);
  }, [setDismissed]);

  if (dismissed) {
    return null;
  }

  return (
    <MessageCallout className={className} onDismiss={handleCalloutDismiss} variety={variety}>
      {children}
    </MessageCallout>
  );
}
